import { transport } from 'config/transport';

export function callApiGetListOfChiCongDoan(congDoanId, month, year) {
    return transport.get(`/congdoan/${congDoanId}/thuchi/chicongdoan`, { params: { month, year } });
}
